import { Sheet } from "common/sheet";
import * as R from "ramda";
import { Background } from "./background";
import { Button } from "./button";
import { toPath } from "./common";
import { Heart } from "./heart";
import { Shade } from "./shade";
import { Title } from "./title";
export const videoFileName = "5번 앞뒤영상.mp4";
export const resourcePaths = [
    ...R.compose(R.chain((n) => [`sheet-${n}.png`, `sheet-${n}.json`]), R.range)(0, 3),
].map((name) => toPath(name));
export async function loadSheets() {
    return await Promise.all(R.compose(R.map((n) => Sheet.load(toPath(`sheet-${n}.png`), toPath(`sheet-${n}.json`))), R.range)(0, 3));
}
export { Background, Button, Shade, Title, toPath, Heart };
//# sourceMappingURL=resources.js.map